module.exports = "/fonts/Patria_Regular.otf?b376fa4109d5e848f124ad7c855423f8";